import { dataUnitEnum } from '../models-enums';

/**
 * Formats unit display string, converting Celsius/Fahrenheit to °C/°F
 * @param unit - The unit enum value
 * @returns Formatted unit string
 */
export const formatUnit = (unit: number): string => {
    const unitString = dataUnitEnum[unit];

    if (unitString === 'Celsius') {
        return '°C';
    }
    if (unitString === 'Fahrenheit') {
        return '°F';
    }

    return unitString;
};
